module.exports = __webpack_public_path__ + "img/pro-photo7.cbd20819.png";